// extracted by mini-css-extract-plugin
export var container = "_7l-0";
export var error = "_7l-9";
export var label = "_7l-5";
export var light = "_7l-6";
export var md = "_7l-3";
export var sm = "_7l-2";
export var thin = "_7l-8";
export var thinBold = "_7l-7";
export var vertical = "_7l-4";
export var xs = "_7l-1";